import { render, staticRenderFns } from "./HomeAlunoScreen.vue?vue&type=template&id=2b286942&scoped=true&"
import script from "./HomeAlunoScreen.vue?vue&type=script&lang=js&"
export * from "./HomeAlunoScreen.vue?vue&type=script&lang=js&"
import style0 from "./HomeAlunoScreen.vue?vue&type=style&index=0&id=2b286942&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b286942",
  null
  
)

export default component.exports